import React from 'react';

export interface AuditLabelName {
    [key: string]: string
}

export interface AuditLabelAction {
    [key: string]: AuditLabelName
}

export interface AuditLabelController {
    [key: string]: AuditLabelAction
}

interface AuditLabelContextData {
    resources: AuditLabelController
}

export default React.createContext<AuditLabelContextData>({
    resources: {}
});